import { authFetch } from "@/lib/api-client";
import type {
  TeamRecipientRow,
  TeamRecipientCreatePayload,
  TeamRecipientUpdatePayload,
} from "@/features/admin/marketplace/types/admin-marketplace.types";

const BASE_PATH = "/marketplace/admin/team-recipients";

// ─── Reads ─────────────────────────────────────────────────────────────────

export async function fetchTeamRecipients(): Promise<TeamRecipientRow[]> {
  const { data } = await authFetch<TeamRecipientRow[]>(BASE_PATH);
  return data;
}

// ─── Mutations ─────────────────────────────────────────────────────────────

export async function createTeamRecipient(
  payload: TeamRecipientCreatePayload,
): Promise<TeamRecipientRow> {
  const { data } = await authFetch<TeamRecipientRow>(BASE_PATH, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return data;
}

export async function updateTeamRecipient(
  recipientId: string,
  payload: TeamRecipientUpdatePayload,
): Promise<TeamRecipientRow> {
  const { data } = await authFetch<TeamRecipientRow>(
    `${BASE_PATH}/${encodeURIComponent(recipientId)}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );
  return data;
}

export async function deleteTeamRecipient(recipientId: string): Promise<string> {
  const { data } = await authFetch<{ id: string }>(
    `${BASE_PATH}/${encodeURIComponent(recipientId)}`,
    { method: "DELETE" },
  );
  return data.id;
}
